/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBoardGameNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBoardGameNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Play Some Board Games!",
    "Board Game Bonanza!",
    "Game On!",
  ],
  title: "Board Game Night",
  description: "Organize an exciting board game night.",
  longDescription:
    "Gather your friends for a night of board game fun! Choose a date, decide on the games to play, and plan snacks for the evening!",
  emoji: "🎲",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Board Game Night",
          emoji: "🎲",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the board game night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on games to play?",
            description: "What board games do we want to include in the night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What games should we choose?",
                emoji: "🃏",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we have during the game night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍪",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Games Begin!",
    outroDescription: "Your board game night plans are set! Enjoy the fun!",
  },
};
